module.exports = __webpack_public_path__ + "img/blocking.0ce7eaa9.svg";